// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2niHp","content":"styles_content__1ydl5","flexButton":"styles_flexButton__3Ttfw","formikErrors":"styles_formikErrors__3u_tf"};